import { ToastProvider } from './ToastProvider';

// TODO: in v9, move styled() from ToastProvider.jsx to here
export var StyledToastProvider = ToastProvider;